<template>
  <v-row>
    <v-col cols="12" class="pa-3" v-if="!loading">
      <showConvocationForm v-if="entrepreneurship.version=='v1'" :data="entrepreneurship" />
      <showConvocationFormV2 v-if="entrepreneurship.version=='v2'" :data="entrepreneurship" />
      <showConvocationFormV3 v-if="entrepreneurship.version=='v3'" :data="entrepreneurship" />
    </v-col>

    <v-col cols="12" class="d-sm-flex pt-8">

      <v-btn 
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        depressed
        color="primary"
        :to="{ name: 'showEntrepreneurshipListAdmin' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        depressed
        color="primary"
        :loading="loading_download"
        @click="downloadPDF" >
        <v-icon
          dark
        >
          mdi-download
        </v-icon>
        Descargar PDF
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API

  import showConvocationForm from '@/components/convocation_form/showConvocationForm.vue'
  import showConvocationFormV2 from '@/components/convocation_form/showConvocationFormV2.vue'
  import showConvocationFormV3 from '@/components/convocation_form/showConvocationFormV3.vue'

  export default {
    name: 'showEntrepreneurshipListConvocationFormAdmin',
    components: {
      showConvocationForm,
      showConvocationFormV2,
      showConvocationFormV3
    },
    data: () => ({
      loading_download:false,
      loading:true,
      loading_btn:false,

      entrepreneurship_id:null,
      
      url:null,

      entrepreneurship:[]
    }),

    methods:{
      async getConvocationForm(){
        await axios.get('admin/entrepreneurships/'+this.entrepreneurship_id+'/convocation-form').then(response =>{
          this.entrepreneurship = response.data.data.convocation_form
          this.loading=false
        }).catch(error => {
          console.log(error)
        })
      },

      async downloadPDF(){
        this.loading_download=true
        this.url = VUE_URL_API + '/admin/edition/'+this.entrepreneurship.edition_id+'/convocation-form/'+this.entrepreneurship.id+'/generate-pdf'

        await axios.get(
          this.url, 
          {responseType: 'blob'}
        ).then((response) => {
          //window.open(URL.createObjectURL(response.data));
          const content = response.headers['content-type'];
          download(response.data, this.entrepreneurship.id+' - '+ this.entrepreneurship.title , content)
          this.loading_download=false
        })
      },

      async downloadPDF2() {

        await axios({
          url: this.url,
          method: 'GET',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          responseType: 'blob',
        }).then((res) => {
          var FILE = window.URL.createObjectURL(new Blob([res.data]));
        
          var docUrl = document.createElement('x');
          docUrl.href = FILE;
          docUrl.setAttribute('download', 'sample.pdf');
          document.body.appendChild(docUrl);
          docUrl.click();
        });
      },
    },

    created(){
      this.entrepreneurship_id = this.$route.params.entrepreneurship_id;
      this.getConvocationForm()
      },
  }
</script>